import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faQuestion} from '@fortawesome/free-solid-svg-icons'

const IconQuestionCircle = () => (
  <FontAwesomeIcon icon={faQuestion} className="icon-question-circle tw-ml-1.5" />
)

export default IconQuestionCircle
